module.exports = __webpack_public_path__ + "media/src/img/mail-41c541847b663d322824bfd6c8fdf43d.png";